import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { environment } from '../../../../../src/environments/environment';
import { AuthservicesService } from 'src/app/services/authservices.service';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.css'],
})
export class SignInComponent implements OnInit {
  form: FormGroup;
  submitted = false;
  error: string;
  id;
  loading = false;
  errorMessage;
  fieldTextType = false;
  constructor(
    public router: Router,
    public fb: FormBuilder,
    private authservice: AuthservicesService
  ) {}

  ngOnInit(): void {
    this.errorMessage = environment.errorMessage;
    this.form = this.fb.group({
      email: [null, [Validators.required, Validators.email]],
      password: [null, [Validators.required, Validators.minLength(6)]],
    });
  }

  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }

  get f() {
    return this.form.controls;
  }

  onSubmit(): void {
    this.submitted = true;
    if (this.form.invalid) {
      return;
    }
    if (this.form.valid) {
      let email = this.form.get('email').value;
      let password = this.form.get('password').value;
      let deviceType = 'web';
      let version = '1';
      let role = 'Community';
      let obj = {
        email: email,
        password: password,
        deviceType: deviceType,
        version: version,
        role: role,
      };
      this.authservice.login(obj).subscribe(
        (data) => {
          localStorage.setItem('ministry_id', data._id);
          this.id = data._id;
          let user = JSON.parse(localStorage.getItem('ministry_currentUser'));
          let completeReg = JSON.parse(localStorage.getItem('completeReg'));

          console.log(user.isEmailVarified, user.isFirstUpdateDone);
          if (user.isEmailVarified == true && user.isFirstUpdateDone == true) {
            this.router.navigate(['/profile-management']);

            this.authservice.successMessage(
              environment.loginSuccessfullyMessage,
              'success'
            );
          } else if (
            user.isEmailVarified == true &&
            user.isFirstUpdateDone == false
          ) {
            let info = { email: email, name: '' };
            localStorage.setItem('user', JSON.stringify(info));
            this.router.navigate(['/user-registration/basic-info']);
            this.authservice.successMessage(
              environment.resgisterationCompleteMessage,
              'success'
            );
          } else if (
            user.isEmailVarified == false &&
            user.isFirstUpdateDone == false
          ) {
            let info = { email: email, name: '' };
            localStorage.setItem('userobj', JSON.stringify(user));

            // localStorage.setItem('user', JSON.stringify(info));
            this.router.navigate(['/email-verification']);

            this.authservice.successMessage(environment.verifyEmail, 'success');
          }
        },
        (error) => {
          if (error.status == 401) {
            localStorage.removeItem('ministry_currentUser');
          } else {
            this.authservice.successMessage(error.error.message, 'error');
          }
        }
      );
    }
  }
}
